import memoize from 'lodash/memoize';
import { createSelector } from '@reduxjs/toolkit';
import type { NetworkRequest } from 'c-data-layer';
import { NetworkRequestState } from 'c-data-layer';
import type { CommonState } from 'c-types/RootState';

const getAttachingDictionary = (state: CommonState) => state.campaignReporting.attachingConfigById;

const idleState = { state: NetworkRequestState.Idle } as NetworkRequest;

export const getAttachingConfigById = createSelector(getAttachingDictionary, attaching =>
    memoize((id: number) => attaching[id] ?? idleState),
);
